import React, { useEffect, useState } from 'react';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { SupportRequestAlert } from '../../../../templates/components/customers/components/alerts/supportError/SupportRequestAlert';
import ReceiptLayout from '../receipt.layout';
import PreviewComponent from '../components/preview.component';
import IllustrationComponent from '../components/illustration.component';
import { formatDateTime12Hrs } from '../../../../utils/date-time';
import { useReceiptContext } from '../context/receipt.context';
import { handleLoginCreate } from '../../../../utils/signInOutUp/AuthenticationHelper';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import ReceiptHelper from '../helpers/receipt.helper';
import { STORE_LOCATIONS } from '../../../../utils/location/locationHelper';

const receiptHelper = new ReceiptHelper();

const AlreadyClaimedView = ({ receiptId, history, isPerksDisabled }) => {
  const { data, isLoading, trackingData, isLinked, clearSession } = useReceiptContext();
  const { tracker } = useTrackingContext();
  const [downloadError, setDownloadError] = useState(null);

  useEffect(() => {
    if (receiptId && receiptId === data?.receipt?.ReceiptData?.Code) {
      if (!isLinked && !data.verify?.raw?.data?.phone) {
        history.push(`/${receiptId}`);
      } else if (
        data.receipt.ErrorCode &&
        (data.receipt.ErrorCode === 'InvalidReceiptCode' || data.receipt.ErrorCode === 'InvalidData')
      ) {
        history.push(`/`);
      }
    }
  }, [data]);

  useEffect(() => {
    tracker.group = 'claimed';
    tracker.extraData = {
      ...tracker.extraData,
      purchases: [{ type: 'in-store receipts', receiptId, ...trackingData }],
    };
    tracker.trackView();
  }, []);

  const receiptData = data.receipt?.ReceiptData;
  const storeName = receiptData?.LocationDescription;
  const dateTime = receiptData && formatDateTime12Hrs(new Date(receiptData?.SaleDateTime));
  const preventAutoDownload = window.location.href.includes('autoDownload=false');

  const handleLogin = () => {
    tracker.trackClick({ label: 'log in' });
    handleLoginCreate(`${window.location.pathname}#/${receiptId}/post-login`, {}, { fromReceiptsMicrosite: true });
  };

  const handleViewInMyAccount = () => {
    tracker.trackClick({ label: 'view in my account' });
    clearSession();
    receiptHelper.redirectToAccount(receiptId);
  };
  const supportRequestId = window.Jbhifi?.storeLocation === STORE_LOCATIONS.NZ ? '14820252324377' : '360006301073';

  return (
    <ReceiptLayout ripped wide isLoading={isLoading}>
      <div>
        {downloadError ? (
          <div className="claimed-support-alert-container">
            <SupportRequestAlert
              content="Please try again or"
              heading="Can't download receipt"
              inlineSupportLink
              supportRequestId={supportRequestId}
              supportRequestLabel="contact us"
              supportRequestPrefilledAccountEnquiryType="digital_receipts"
              type="error"
            />
          </div>
        ) : null}
        <div className="claimed-layout">
          <IllustrationComponent name="claimed" />

          <div className="claimed-text-container">
            <PreviewComponent storeName={storeName} dateTime={dateTime} />
            <div className="claimed-alert-container">
              <Alert heading="Saved to your account" showIcon type="success" inline />
            </div>
            <div className="claimed-button-container">
              {window.Jbhifi?.customerDetails?.isLoggedIn ? (
                <JBButton type="primary" label="View in My Account" fullWidth={true} onClick={handleViewInMyAccount} />
              ) : (
                <JBButton type="primary" label="Log in" fullWidth={true} onClick={handleLogin} />
              )}
            </div>
          </div>
        </div>
      </div>
    </ReceiptLayout>
  );
};

export default AlreadyClaimedView;
